import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './FullScreenModalLayoutContent.st.css';
import BaseModalLayout from '../../../BaseModalLayout';
import { FullScreenModalLayoutContentProps } from '../../FullScreenModalLayout.types';
import { DATA_HOOKS } from '../../FullScreenModalLayout.constants';

const FullScreenModalLayoutContent = ({
  children,
  padding = false,
  dataHook,
  className,
}: FullScreenModalLayoutContentProps) => {
  return (
    <BaseModalLayout.Content
      dataHook={dataHook || DATA_HOOKS.fullScreenModalLayoutContent}
      className={st(classes.root, { padding }, className)}
    >
      {children}
    </BaseModalLayout.Content>
  );
};

FullScreenModalLayoutContent.displayName = 'FullScreenModalLayout.Content';

FullScreenModalLayoutContent.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in tests. */
  dataHook: PropTypes.string,
  /**
   * Allows you to apply a CSS class to the component's root element.
   * @internal
   **/
  className: PropTypes.string,
  /** Content node */
  children: PropTypes.node.isRequired,
  /**
   * If true, applies padding to the content
   * @default false
   **/
  padding: PropTypes.bool,
};

export default FullScreenModalLayoutContent;
